module.exports = __webpack_public_path__ + "img/9788994115221.43fdc8a0.jpg";